import moment from 'moment';

import { getRandom } from '../../utils/random';

const WINDOW_DAYS = 30;

const EARLIEST_ELIGIBLE_SERVICE_START = '2026-09-01T00:00:00Z';

const VoiceNotePilotGroup = {
  VARIANT: 'VARIANT',
  CONTROL: 'CONTROL',
};

const SEED_NAMESPACE = 'M2VoiceNotePilot';

const VARIANT_SHARE = 0.5;

const getVoiceNotePilotGroup = (clientId) => (
  getRandom(`${SEED_NAMESPACE}|${clientId}`) < VARIANT_SHARE
    ? VoiceNotePilotGroup.VARIANT
    : VoiceNotePilotGroup.CONTROL
);

const getVoiceNotePilotBannerGroup = ({
  isCoachOrAdmin,
  isPilotCoach,
  canMessageClient,
  clientId,
  firstServiceStartAt,
  now = new Date(),
}) => {
  if (!isCoachOrAdmin || !isPilotCoach || !canMessageClient || !clientId) {
    return null;
  }

  if (!firstServiceStartAt) {
    return null;
  }

  if (moment(firstServiceStartAt).isBefore(EARLIEST_ELIGIBLE_SERVICE_START)) {
    return null;
  }

  if (moment(now).isBefore(firstServiceStartAt)) {
    return null;
  }

  if (!moment(now).isBefore(moment(firstServiceStartAt).add(WINDOW_DAYS, 'days'))) {
    return null;
  }

  return getVoiceNotePilotGroup(clientId);
};

export {
  VoiceNotePilotGroup,
  getVoiceNotePilotGroup,
  getVoiceNotePilotBannerGroup,
};
